'use strict';

angular.module('app.commonPages', [])
	.controller('commonPagesCtrl', ['$scope', '$modal', 'adminService', 'commonPagesService',
		function ($scope, $modal, adminService, commonPagesService) {
		    
		    $scope.preLoaded = false;
		    $scope.currentPage = 1;
		    $scope.pageSize = 25;
		    $scope.hasValue = null;

		    //server-side
		    $scope.preLoadData = function(hasValue, flag){
		        if(hasValue == null){
		            var params = {
		                searchCommonPages: $scope.searchCommonPagesString,
		                pageNo: $scope.currentPage,
		            }

		            $scope.sendHttpPOST(params, true);
		        }
		        $scope.preLoaded = true;
		       
		    }

		    $scope.sendHttpPOST = function(params, loader){
		    	commonPagesService.getCommonPages(params, loader)
		    		.then(function(response) {
		    			$scope.commonPages = response.data;
			            $scope.number = response.totalRow;   
			            $scope.pagination();
		    		}, function(response) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		    		})
		    }

		    if(!$scope.preLoaded){
		        $scope.preLoadData($scope.hasValue);
		    }

		    $scope.pagination = function(){
		        $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
		    };

		    $scope.updatePage = function(val,flag){
		        $scope.currentPage = val;
		        var params = {
		            searchCommonPages: $scope.searchCommonPagesString,
		            pageNo: $scope.currentPage,
		       } 

		       $scope.sendHttpPOST(params, true);
		    }

		    $scope.searchCommonPages = function(flag){
		        var params = {
		            searchCommonPages: $scope.searchCommonPagesString,
		            pageNo: 1,         
		        }

		        $scope.currentPage = 1;
		        $scope.sendHttpPOST(params, true);        
		    }

		    $scope.newCommonPagesHandler = function () {
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/commonPages/addNewCommonPage/addNewCommonPage.html?app_v=deployDate',
		            controller: 'addNewCommonPageCtrl'
		        });

		        $scope.modalInstance = modalInstance;
		    }

		    $scope.commonPagesDetail = function (index) {
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/commonPages/commonPageDetail/commonPageDetail.html?app_v=deployDate',
		            controller: 'commonPageDetailCtrl'
		        });
		        $scope.modalInstance = modalInstance;
		        $scope.index = index;
		    }   
}])
